/**
 * umi `request()` 返回 axios body，不会像 `useRequest` 那样按 dataField 解包。
 * 网关/BFF 常见形态是 `{ success, data }`；裸数组或已解包对象原样返回。
 */
export const unwrapBizResponse = <T = unknown>(body: unknown): T => {
  if (
    body &&
    typeof body === 'object' &&
    !Array.isArray(body) &&
    'data' in body &&
    ('success' in body || 'errorCode' in body || 'errorMessage' in body)
  ) {
    return (body as { data: T }).data;
  }
  return body as T;
};
